import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { WhyTipsFail } from './components/WhyTipsFail';
import { Mapa3DSection } from './components/Mapa3DSection';
import { CryingObjection } from './components/CryingObjection';
import { WhatsIncluded } from './components/WhatsIncluded';
import { WhoItsFor } from './components/WhoItsFor';
import { ExpectationsSection } from './components/ExpectationsSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function initMetaPixel() {
  if (window.fbq) return;
  const n: any = window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!window._fbq) window._fbq = n;
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  n.queue = [];
  const t = document.createElement('script');
  t.async = true;
  t.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(t);
  window.fbq('init', '4162995907344908');
  window.fbq('track', 'PageView');
}
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <main className="min-h-screen w-full bg-[#0c1425] text-cream overflow-x-hidden selection:bg-amber-500/30 selection:text-amber-100" data-id="element-0">
      {/* Meta Pixel noscript fallback */}
      <noscript data-id="element-1">
        <img height="1" width="1" style={{
        display: 'none'
      }} src="https://www.facebook.com/tr?id=4162995907344908&ev=PageView&noscript=1" alt="" data-id="element-2" />
      </noscript>
      <HeroSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <WhyTipsFail data-id="element-5" />
      <Mapa3DSection data-id="element-6" />
      <CryingObjection data-id="element-7" />
      <WhatsIncluded data-id="element-8" />
      <WhoItsFor data-id="element-9" />
      <ExpectationsSection data-id="element-10" />
      <CTASection data-id="element-11" />
      <Footer data-id="element-12" />
    </main>;
}